export default __webpack_public_path__ + "static/media/FeverInTheOceans_11.7317a9ab.png";